import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { getContainerCategories } from '@/api/containerCategoriesAPI'

interface Category {
  id: number
  name: string
}

interface CategoriesResponse {
  items: Category[]
}

export const useCategoriesQuery = (search?: string) => {
  return useQuery<CategoriesResponse>({
    queryKey: ['containerCategories', search],
    queryFn: async () => {
      const categories = await getContainerCategories()
      let items = categories

      // Filter locally if there's search (API doesn't support search)
      if (search && search.trim() !== '') {
        const searchLower = search.toLowerCase()
        items = categories.filter((cat) =>
          cat.name.toLowerCase().includes(searchLower)
        )
      }

      return { items }
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    placeholderData: keepPreviousData,
  })
}

export const categoriesToOptions = (categories: Category[] = []) => {
  return [
    { value: 'all', label: 'Todas' },
    ...categories.map((category) => ({
      value: String(category.id),
      label: category.name,
    })),
  ]
}
